import React from 'react';
import { useTranslation } from 'react-i18next';

import { CustomTabInfo, TAB_NAMES } from 'editor/src/store/editorModules/sidebar/types';

import Tab from 'editor/src/component/DesktopSidebar/Tabs/Tab/index';
import IconLayouts from 'editor/src/component/Icon/IconLayouts';

interface Props {
  pluginName?: string;
  customTabInfo?: CustomTabInfo;
  active?: boolean;
}

function LayoutsTab({ pluginName, customTabInfo, active }: Props) {
  const { t } = useTranslation();

  return (
    <Tab
      key={TAB_NAMES.LAYOUTS}
      name={TAB_NAMES.LAYOUTS}
      title={t('editor-layouts')}
      icon={<IconLayouts active={active} />}
      pluginName={pluginName}
      customTabInfo={customTabInfo}
    />
  );
}

export default React.memo(LayoutsTab);
